import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['addButton', 'fields'];

  connect() {
    // 初期状態で3つ以上のフィールドが表示されている場合、追加ボタンを非表示にする(編集時)
    if (this.fieldsTargets.filter((field) => !field.classList.contains('hidden')).length >= 3) {
      this.addButtonTarget.classList.add('hidden');
    }
  }

  hideAddButtonOnReachLimit() {
    // 「トラックを追加」ボタンクリック時、2つ以上のフィールドが表示されていたら追加ボタンを非表示にする
    if (this.fieldsTargets.filter((field) => !field.classList.contains('hidden')).length >= 2) {
      this.addButtonTarget.classList.add('hidden');
    }
  }

  showAddButtonOnFallBelowLimit() {
    // 「トラック削除」ボタンクリック時、3つ以下のフィールドが表示されていたら追加ボタンを表示する
    if (this.fieldsTargets.filter((field) => !field.classList.contains('hidden')).length <= 3) {
      this.addButtonTarget.classList.remove('hidden');
    }
  }
}
